module.exports = __webpack_public_path__ + "img/deploy.f2c0080a.jpg";